export default __webpack_public_path__ + "static/Pluto-Cond-Black-f3df5a3db879f59c710e384b2bc0e57f.woff2";